import React from 'react';

/**
 * Renderiza el bloque SimpleRanking de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function SimpleRanking({
  v
}) {
  return React.createElement("section", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "padding": "1.111111vh 1.481481vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh",
      "minHeight": "0"
    }
  }, v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "flexWrap": "wrap",
      "gap": "0.37037vh 1.481481vh",
      "fontSize": "1.111111vh",
      "color": "#8793a6",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("h2", {
    style: {
      "margin": "0",
      "fontSize": "1.296296vh",
      "fontWeight": "600",
      "color": "#e4e9f0",
      "whiteSpace": "nowrap"
    }
  }, v.text("Centro en el tiempo")), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.520833vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": "oklch(0.8 0.13 85 / 0.7)"
    }
  }, null), v.text(v.tlAlLab)), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.729167vw",
      "height": "0.185185vh",
      "background": "oklch(0.7 0.17 45)"
    }
  }, null), v.text("SFR promedio")), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.729167vw",
      "height": "0.185185vh",
      "background": "oklch(0.72 0.16 350)"
    }
  }, null), v.text("PPA acumulado "), React.createElement("span", {
    style: {
      "color": "#5a667a"
    }
  }, v.text("(escala propia, máx.")), v.text(" "), React.createElement("b", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": "oklch(0.78 0.14 350)"
    }
  }, v.text(v.tlCumEnd)), React.createElement("span", {
    style: {
      "color": "#5a667a"
    }
  }, v.text(")")))), v.text("\n      "), React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "position": "relative",
      "margin": "0.185185vh 4.074074vh 1.481481vh 3.703704vh"
    }
  }, v.text("\n        "), (v.tlAl || []).map((y, index105) => React.createElement(React.Fragment, {
    key: index105
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": y.top,
      "borderTop": "0.092593vh solid rgba(135,147,166,0.12)"
    }
  }, null), React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "calc(100% + 0.3125vw)",
      "top": y.top,
      "transform": "translateY(-50%)",
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "color": "oklch(0.8 0.13 85)"
    }
  }, v.text(y.lab)))), v.text("\n        "), (v.tlSf || []).map((y, index106) => React.createElement(React.Fragment, {
    key: index106
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "left": "calc(100% + 0.3125vw)",
      "top": y.top,
      "transform": "translateY(-50%)",
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "color": "oklch(0.7 0.17 45)",
      "whiteSpace": "nowrap"
    }
  }, v.text(y.lab)))), v.text("\n        "), React.createElement("svg", {
    "viewBox": "0 0 1000 100",
    "preserveAspectRatio": "none",
    style: {
      "position": "absolute",
      "inset": "0",
      "width": "100%",
      "height": "100%",
      "display": "block",
      "overflow": "visible"
    }
  }, React.createElement("path", {
    "d": v.tlBars,
    "fill": "oklch(0.8 0.13 85)",
    "fillOpacity": "0.55"
  }, null), React.createElement("path", {
    "d": v.tlRef,
    "stroke": "oklch(0.7 0.17 45)",
    "strokeWidth": "1",
    "strokeDasharray": "5 4",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke",
    "opacity": "0.7"
  }, null), React.createElement("path", {
    "d": v.tlCumArea,
    "fill": "oklch(0.72 0.16 350)",
    "fillOpacity": "0.07"
  }, null), React.createElement("path", {
    "d": v.tlCum,
    "stroke": "oklch(0.72 0.16 350)",
    "strokeWidth": "2",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke",
    "strokeLinejoin": "round"
  }, null), React.createElement("path", {
    "d": v.tlLine,
    "stroke": "oklch(0.7 0.17 45)",
    "strokeWidth": "2",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke",
    "strokeLinejoin": "round"
  }, null)), v.text("\n        "), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "-0.37037vh",
      "bottom": "0",
      "left": v.tlSel,
      "width": "0.104167vw",
      "marginLeft": "-0.052083vw",
      "background": "oklch(0.85 0.1 225)",
      "pointerEvents": "none"
    }
  }, null), v.text("\n        "), v.tlCur ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "left": v.tlCurL,
      "width": "0.052083vw",
      "background": "rgba(228,233,240,0.55)",
      "pointerEvents": "none"
    }
  }, null), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "left": v.tlTip.L,
      "transform": v.tlTip.tx,
      "zIndex": "10",
      "width": "10.416667vw",
      "background": "rgba(6,14,28,0.96)",
      "border": "0.092593vh solid rgba(46,179,238,0.35)",
      "borderRadius": "0.740741vh",
      "padding": "0.740741vh 0.925926vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.37037vh",
      "pointerEvents": "none",
      "boxShadow": "0 0.740741vh 2.222222vh rgba(0,0,0,0.45)"
    }
  }, React.createElement("span", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": "#e4e9f0"
    }
  }, v.text(v.tlTip.title)), (v.tlTip.rows || []).map((x, index107) => React.createElement(React.Fragment, {
    key: index107
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "0.740741vh",
      "fontSize": "1.111111vh"
    }
  }, React.createElement("span", {
    style: {
      "color": x.c,
      "whiteSpace": "nowrap"
    }
  }, v.text(x.l)), React.createElement("span", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": "#e4e9f0",
      "whiteSpace": "nowrap"
    }
  }, v.text(x.v))))))) : null, v.text("\n        "), React.createElement("div", {
    "onMouseLeave": v.tlLeave,
    style: {
      "position": "absolute",
      "inset": "0",
      "display": "flex",
      "zIndex": "4"
    }
  }, (v.tlHits || []).map((h, index108) => React.createElement(React.Fragment, {
    key: index108
  }, React.createElement("div", {
    "onMouseEnter": h.enter,
    "onClick": h.click,
    style: {
      "flex": "1",
      "minWidth": "0",
      "cursor": "pointer"
    }
  }, null)))), v.text("\n        "), (v.tlX || []).map((x, index109) => React.createElement(React.Fragment, {
    key: index109
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "top": "calc(100% + 0.37037vh)",
      "left": x.left,
      "transform": "translateX(-50%)",
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "color": "#8793a6",
      "whiteSpace": "nowrap"
    }
  }, v.text(x.lab)))), v.text("\n      ")), v.text("\n    "));
}
